import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ReportProfile {
  @JsonProperty()
  originType?: ReportProfile.ORIGIN_TYPE = ReportProfile.ORIGIN_TYPE.ARCHIVE;

  @JsonProperty()
  active?: boolean = false;

  @JsonProperty()
  originName?: string | undefined;

  @JsonProperty()
  name?: string | undefined;

  @JsonProperty()
  title: string | undefined;

  @JsonProperty()
  type?: string | undefined;

  @JsonProperty()
  exportTemplate: string | undefined;

  @JsonProperty()
  exportFormat: ReportProfile.EXPORT_FORMAT = ReportProfile.EXPORT_FORMAT.CSV;

  @JsonProperty()
  executionTimes?: DateTime[];

  @JsonProperty()
  executionDaysOfMonthJS?: string;

  @JsonProperty()
  executionDaysOfMonth?: number[] = [];

  @JsonProperty()
  executionCron?: string | undefined;

  @JsonProperty()
  transferMailSubject?: string | undefined;

  @JsonProperty()
  transferMailTemplate?: string | undefined;

  @JsonProperty()
  transferMailRecipients?: string[];

  @JsonProperty()
  transferFileLocations?: string[];

  @JsonProperty()
  exportDateMode: ReportProfile.EXPORT_DATE_MODE =  ReportProfile.EXPORT_DATE_MODE.DAY_BEFORE;

  @JsonProperty()
  visibility?: ReportProfile.VISIBILITY_RULE= ReportProfile.VISIBILITY_RULE.PUBLIC;

  @JsonProperty()
  user?: string | undefined;

  @JsonProperty()
  userGroup?: string | undefined;

  @JsonProperty()
  zipFile?: boolean = false;

  @JsonProperty()
  mailAlert?: boolean = false;

  @JsonProperty()
  differential?: boolean = false;

  @JsonProperty()
  ignoreEmpty?: boolean = false;

  @JsonProperty()
  filterMap: any;

  @JsonProperty()
  filters?: any[];

}

export module ReportProfile {
  export enum ORIGIN_TYPE {
    ARCHIVE = 'ARCHIVE', XPORTER = 'XPORTER'
  }

  export enum EXPORT_DATE_MODE {
    DAY_BEFORE = 'DAY_BEFORE',
    CURRENT_DAY = 'CURRENT_DAY',
    CUSTOM = 'CUSTOM',
    CURRENT_MONTH = 'CURRENT_MONTH',
    PREVIOUS_MONTH = 'PREVIOUS_MONTH',
    FROM_DAY = 'FROM_DAY'
  }

  export enum VISIBILITY_RULE {
    PUBLIC = 'PUBLIC', ADMIN = 'ADMIN', USER = 'USER', USER_GROUP = 'USER_GROUP', PROFILES = 'PROFILES', FORMS = 'FORMS'
  }

  export enum EXPORT_FORMAT {
    CSV = 'CSV',
    XLS = 'XLS',
    XLSX = 'XLSX',
    PDF = 'PDF'
  }
}

